import { ProtocolFactory } from 'lib/protocols';

export const protocolFactory = new ProtocolFactory<{}>({
  name: 'LayoutRouterView',
  editorProps: [],
  themeProps: [],
});

export const defaultProps = protocolFactory.createDefaultProps();
